import { render, staticRenderFns } from "./surveyfiles.vue?vue&type=template&id=4e073ece&scoped=true&"
import script from "./surveyfiles.vue?vue&type=script&lang=ts&"
export * from "./surveyfiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e073ece",
  null
  
)

export default component.exports